/**
 * Created by glopez on 24/04/17.
 */
import {ActionTypes} from 'store/actions/modals/dialog';

const defaultState = {
    title: '',
    subtitle: '',
    text: '',
    buttons: []
};

/**
 * Confirm reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} Confirm reducer.
 */
export default function dialog (state = defaultState, action) {

    switch (action.type) {

        case ActionTypes.SET_DIALOG_DATA:
            return (state = {
                ...(action.data || defaultState)
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/modals/dialog.js